<template>
    <div class="w-full space-y-3">
        <Head title="Management Fees"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Management Fees</h1>
        </div>
    </div>
    <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col"
                                    class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    Organisation Name
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-if="organisations.data.length > 0" v-for="(organisation, index) in organisations.data"
                                    :key="index"
                                    :class="{'bg-gray-100': index % 2}"
                                    class="hover:bg-gray-50 cursor-pointer">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <Link :href="route('frontend.management-fees.organisation.index', [organisation.id])" class="underline">{{ organisation.name }}</Link>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="8"
                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        There are no organisations available.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link, Head} from "@inertiajs/vue3";
import Authenticated from "@/Layouts/Authenticated";
import SearchFilter from "@/Components/SearchFilter";
import {CreditCardIcon, TrashIcon, PencilAltIcon} from "@heroicons/vue/outline";

export default {
    layout: Authenticated,
    components: {
        Head,
        Link,
        TrashIcon,
        SearchFilter,
        PencilAltIcon,
        CreditCardIcon
    },
    props: {
        organisations: Object
    }
}
</script>
